(() => {
  const sortLabels = {
    manual: 'AANBEVOLEN',
    'price-ascending': 'PRIJS: LAAG–HOOG',
    'price-descending': 'PRIJS: HOOG–LAAG',
    'title-ascending': 'NAAM: A–Z',
    'title-descending': 'NAAM: Z–A',
    'created-descending': 'NIEUWSTE EERST',
  };

  const initShopControls = (root = document) => {
    root.querySelectorAll('[data-fp-shop-controls]').forEach((controls) => {
      if (controls.dataset.ready) return;

      const productGrid = document.querySelector('[data-fp-products]');
      if (!productGrid) return;

      controls.dataset.ready = 'true';
      const cards = [...productGrid.querySelectorAll('.fp-product-card')];
      let collectionOrders = {};
      try {
        collectionOrders = JSON.parse(document.querySelector('[data-fp-collection-order]')?.textContent || '{}');
      } catch (error) {
        console.warn('Collection order could not be read', error);
      }
      const collectionRanks = new Map(Object.entries(collectionOrders).map(([handle, productIds]) => [
        handle,
        new Map(productIds.map((productId, index) => [String(productId), index])),
      ]));
      const buttons = [...controls.querySelectorAll('[data-collection-handle]')];
      const sort = controls.querySelector('[data-fp-sort]');
      const sortLabel = controls.querySelector('[data-fp-sort-label]');
      const filterLabel = controls.querySelector('[data-fp-filter-label]');
      const emptyState = document.querySelector('[data-fp-shop-empty]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      const activeCollections = new Set();
      const initialCollection = controls.dataset.activeCollection || 'all';
      activeCollections.add(initialCollection);

      const multiHash = window.location.hash.match(/^#collecties-(.+)$/)?.[1];
      const singleHash = window.location.hash.match(/^#collectie-(.+)$/)?.[1];
      const hashCollections = multiHash ? multiHash.split(',') : (singleHash ? [singleHash] : []);
      const validHandles = new Set(buttons.map((button) => button.dataset.collectionHandle));
      const validHashCollections = hashCollections.filter((handle) => handle !== 'all' && validHandles.has(handle));
      if (validHashCollections.length) {
        activeCollections.clear();
        validHashCollections.forEach((handle) => activeCollections.add(handle));
      }

      const compareCards = (a, b) => {
        switch (sort?.value) {
          case 'price-ascending': return Number(a.dataset.productPrice) - Number(b.dataset.productPrice);
          case 'price-descending': return Number(b.dataset.productPrice) - Number(a.dataset.productPrice);
          case 'title-ascending': return a.dataset.productTitle.localeCompare(b.dataset.productTitle, 'nl');
          case 'title-descending': return b.dataset.productTitle.localeCompare(a.dataset.productTitle, 'nl');
          case 'created-descending': return Number(b.dataset.productCreated) - Number(a.dataset.productCreated);
          default: {
            const originalOrder = Number(a.dataset.productIndex) - Number(b.dataset.productIndex);
            if (activeCollections.has('all')) return originalOrder;

            const selectedHandles = buttons
              .map((button) => button.dataset.collectionHandle)
              .filter((handle) => handle !== 'all' && activeCollections.has(handle));
            const rank = (card) => {
              for (let group = 0; group < selectedHandles.length; group += 1) {
                const position = collectionRanks.get(selectedHandles[group])?.get(card.dataset.productId);
                if (position !== undefined) return [group, position];
              }
              return [selectedHandles.length, Number(card.dataset.productIndex)];
            };
            const [aGroup, aPosition] = rank(a);
            const [bGroup, bPosition] = rank(b);
            return aGroup - bGroup || aPosition - bPosition || originalOrder;
          }
        }
      };

      const updateSortLabel = () => {
        if (!sortLabel || !sort) return;
        const label = sortLabels[sort.value] || sortLabels.manual;
        sortLabel.textContent = mobileQuery.matches ? label : `SORTEER OP: ${label}`;
      };

      const applyShopState = () => {
        const orderedCards = [...cards].sort(compareCards);
        let visibleCount = 0;

        orderedCards.forEach((card) => {
          const collectionHandles = (card.dataset.productCollections || '').split(/\s+/).filter(Boolean);
          const showAll = activeCollections.has('all');
          const isVisible = showAll || [...activeCollections].some((handle) => collectionHandles.includes(handle));
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
          productGrid.append(card);
        });

        buttons.forEach((button) => {
          const isActive = activeCollections.has(button.dataset.collectionHandle);
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        if (filterLabel) filterLabel.textContent = `FILTERS (${activeCollections.has('all') ? 0 : activeCollections.size})`;
        if (emptyState) emptyState.hidden = visibleCount !== 0;
        updateSortLabel();
      };

      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-collection-handle]');
        if (!button) return;
        const collectionHandle = button.dataset.collectionHandle || 'all';
        if (collectionHandle === 'all') {
          activeCollections.clear();
          activeCollections.add('all');
        } else {
          activeCollections.delete('all');
          if (activeCollections.has(collectionHandle)) activeCollections.delete(collectionHandle);
          else activeCollections.add(collectionHandle);
          if (!activeCollections.size) activeCollections.add('all');
        }

        const selectedHandles = [...activeCollections].filter((handle) => handle !== 'all');
        const nextHash = selectedHandles.length
          ? `#collecties-${selectedHandles.join(',')}`
          : `${window.location.pathname}${window.location.search}`;
        window.history.replaceState(null, '', nextHash);
        applyShopState();
      });

      sort?.addEventListener('change', applyShopState);
      mobileQuery.addEventListener?.('change', updateSortLabel);
      applyShopState();
    });
  };

  const initCountdowns = (root = document) => {
    root.querySelectorAll('[data-fp-countdown]').forEach((countdown) => {
      if (countdown.dataset.ready) return;
      countdown.dataset.ready = 'true';
      const target = new Date(countdown.dataset.target).getTime();
      const values = countdown.querySelectorAll('[data-value]');
      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        const parts = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60];
        values.forEach((value, index) => { value.textContent = String(parts[index] || 0).padStart(2, '0'); });
      };
      update();
      window.setInterval(update, 1000);
    });
  };

  const init = (root) => { initShopControls(root); initCountdowns(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
